import { render, staticRenderFns } from "./HomeServiceIntroduce.vue?vue&type=template&id=d23fbfe0&scoped=true&"
import script from "./HomeServiceIntroduce.vue?vue&type=script&lang=js&"
export * from "./HomeServiceIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./HomeServiceIntroduce.vue?vue&type=style&index=0&id=d23fbfe0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23fbfe0",
  null
  
)

export default component.exports